/**
 * MockDetector - Scan Costs Configuration
 * Single source of truth for all scan costs across Widget, Server & Pricing
 * 
 * IMPORTANT: These costs must match across:
 * - Widget: @mockdetector/widget/src/hooks/useBetaCredits.ts
 * - Server: supabase/functions/record-scan/index.ts
 * - Pricing: src/config/mockdetectorPricing.ts
 * - Pricing Page: src/pages/MockDetectorPricing.tsx
 */

export const SCAN_COSTS = {
  QUICK_SCAN: 2,
  DATABASE_SCAN: 5,
  SCAN_ALL_ROUTES: 8,
  SMART_DEEP_SCAN: 12,
} as const;

export type ScanType = keyof typeof SCAN_COSTS;

/**
 * Get the cost for a specific scan type
 */
export function getScanCost(scanType: ScanType): number {
  return SCAN_COSTS[scanType];
}

/**
 * Check if a scan type is valid
 */
export function isValidScanType(scanType: string): scanType is ScanType {
  return Object.keys(SCAN_COSTS).includes(scanType);
}
